// A spray task can be closed twice: from paper on Spray Records ("Record from
// paper") and from the sprayer's phone ("Sign & finish"). complete_spray_task
// keeps the FIRST and answers the second with that record's spray_id and
// `idempotent: true` — no second record, no second stock movement. The phone
// used to treat that answer as its own save: it said "saved", and its GPS
// track and signature went nowhere.
//
// The phone now attaches its track to the record that was kept (only into an
// empty slot — never over a track the record already has), and says so. Its
// signature and picks are NOT applied: the record that was kept is the signed
// original (paper, or the other phone's), and a second sign-off must not
// rewrite it.

export type AlreadyRecorded = {
  /** The record complete_spray_task kept. */
  sprayId: string
  /** true = the phone's track now hangs on that record; false = it could not
   *  be attached; null = the phone recorded no track. */
  trackAttached: boolean | null
}

/** What complete_spray_task's answer means for THIS sign-off: null when it
 *  recorded ours (a fresh insert, or our own replay after a lost response). */
export function alreadyRecordedFrom(
  data: unknown,
  ourSprayId: string,
): { sprayId: string } | null {
  const d = data as { spray_id?: unknown; idempotent?: unknown } | null
  if (!d || d.idempotent !== true || typeof d.spray_id !== 'string') return null
  return d.spray_id === ourSprayId ? null : { sprayId: d.spray_id }
}

export const ALREADY_RECORDED_TITLE = 'Already recorded'

export function alreadyRecordedMessage(a: AlreadyRecorded): string {
  const head = 'This task was recorded before your sign-off reached the office, from paper or another phone. That record stands.'
  const track = a.trackAttached === true
    ? ' Your GPS track was added to it.'
    : a.trackAttached === false
      ? ' Your GPS track could not be added to it: it already has one, or the connection dropped.'
      : ''
  return `${head}${track} Your signature, the name and the sprayer you picked were not used.`
}
